/**
 * ============================================================================
 * Fetch Interceptor - Supabase Token Injection
 * ============================================================================
 * 
 * This file patches the global fetch function to automatically inject
 * the Supabase JWT token into all requests to /api/trpc.
 * 
 * This is necessary because tRPC's httpBatchLink doesn't properly
 * execute custom fetch functions in production builds.
 * 
 * ============================================================================
 */

// Store the original fetch
const originalFetch = window.fetch;

/**
 * Patched fetch that automatically adds Supabase token to tRPC requests
 */
window.fetch = function (input: RequestInfo | URL, init?: RequestInit): Promise<Response> {
  // Only intercept requests to /api/trpc
  const url = typeof input === 'string' ? input : input instanceof URL ? input.href : input.url;
  
  if (url.includes('/api/trpc')) {
    // Get token from localStorage
    const storageKey = 'sb-rirfypidnzsniygiksvg-auth-token';
    const sessionStr = localStorage.getItem(storageKey);
    
    if (sessionStr) {
      try {
        const session = JSON.parse(sessionStr);
        if (session?.access_token) {
          // Add Authorization header
          const headers = new Headers(init?.headers);
          headers.set('Authorization', `Bearer ${session.access_token}`);
          
          // Merge with existing options
          init = {
            ...init,
            headers,
          };
        }
      } catch (error) {
        console.error('[Fetch Interceptor] Failed to parse session:', error);
      }
    }
  }
  
  // Call original fetch
  return originalFetch(input, init);
};

console.log('[Fetch Interceptor] Supabase token injection enabled for /api/trpc');

